import { createAsyncThunk } from '@reduxjs/toolkit';
import CommonEnumsResource from 'api/service/CommonEnumsResource';

export const listStates = createAsyncThunk('properties/listStates', async () => {
  const commonEnumsResource = new CommonEnumsResource();
  const { status, data } = await commonEnumsResource.list('state');
  if (status === 200) {
    return data;
  }
  return [];
});
